import React from 'react'
import ProjectBanner from './ProjectBanner/ProjectBanner'
import ProjectDetails from './info/info'
import PropertyFilters from './PropertyFilters/PropertyFilters'
import PropertyCards from './PropertyCards/PropertyCards'
import Amenities from './Amenities/Amenities'
import AboutProjectSection from './AboutProject/AboutProject'
import Highlights from './Highlights/Highlights'
import FloorPlans from './FloorPlans/FloorPlans'
import PhotoGallerySection from './PhotoGallery/PhotoGallery'
import DeveloperInfoSection from './DeveloperInfo/DeveloperInfo'
import RERAApprovalSection from './RERAApproval/RERAApproval'
import SpecificationsSection from './Specifications/Specifications'
import NearbySection from './NearbySection/NearbySection'
import PropertyInquiryForm from './PropertyInquiryForm/PropertyInquiryForm'
import { useParams } from 'react-router-dom'
import useFetch from '../../../hooks/useFetch'
import { getProjectById } from '../../../services/projectService'
import LoadingComponent from '../../../Components/LoadingComponent/loading'

const ProjectDetailsPage = () => {
    const { projectId } = useParams(); // Get projectId from URL
    const { data, loading, error } = useFetch(() => getProjectById(projectId), [projectId]);
  
    if (loading) {
      return <LoadingComponent/>
    }
  
    if (error) {
      return <div className="text-center text-red-500 py-10">Error: {error.message}</div>;
    }
  
    if (!data?.project) {
      return <div className="text-center py-10">Project not found.</div>;
    }
  
    const project = data.project;
  
    return (
        <div className='pt-[120px] '>
            <ProjectBanner project={project} />
            <div className='flex max-w-[96%] mx-auto'>
                <div className='w-[70%] border my-10'>
                    <ProjectDetails project={project}/>
                    <PropertyFilters/>
                    <PropertyCards/>
                    <Amenities amenitiesData = {project?.amenities || {}}/>
                    <AboutProjectSection project={project}/>
                    <Highlights project={project}/>
                    <DeveloperInfoSection/>
                    <FloorPlans project={project}/>
                    <PhotoGallerySection project={project}/>
                    <RERAApprovalSection/>
                    <SpecificationsSection project={project}/>
                    <NearbySection project={project}/>
                </div>
                <div className='w-[30%] h-min my-10 sticky top-32'>
                    <PropertyInquiryForm/>
                </div>
            </div>
        </div>
    )
}

export default ProjectDetailsPage